/// <amd-module name="Feed/Legacy/Extensions/PackageHubRoot" />
import * as React from "react";

import { useComponentContext, VssComponent } from "VSS/Platform/Layout";
import { RootProvider } from "VSS/Redux/RootProvider";

import { PerfScenarios } from "Feed/Common/Constants/Constants";
import { getFeedHubModules } from "Feed/Core/Redux/FeedHub";

import { ConnectedPackageHub } from "./Package.Hub";

function PackageHubRoot() {
    const context = useComponentContext();

    return (
        <RootProvider
            initialState={{}}
            sagaContext={context}
            scenarioName={PerfScenarios.Area}
            modules={getFeedHubModules()}
            useStoreService={true}
        >
            <ConnectedPackageHub />
        </RootProvider>
    );
}

VssComponent.register("ms-feed-packages-hub", PackageHubRoot);
